export const EntityTypeEnum:Record<API.Entity.Type,string> = {
  'ENTERPRISE': '企业',
  'INDIVIDUAL': '个人',
  'INDIVIDUAL_BUSINESS': '个体户',
}